/**
 * CookieConsent: Persistent Bottom-Left Cyber-Glass Cookie Banner
 *
 * Architecture: Nirajan <https://nbk.com.np>
 */

export function initCookieConsent() {
  const banner = document.getElementById('nbk-cookie-banner');
  if (!banner) return;

  const acceptBtn = document.getElementById('nbk-cookie-accept');
  const declineBtn = document.getElementById('nbk-cookie-decline');

  const consentKey = 'nbk_cookie_consent';
  let currentConsent = null;

  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      currentConsent = window.localStorage.getItem(consentKey);
    }
  } catch {
    // LocalStorage might be disabled in private mode
  }

  // If already consented, stay hidden
  if (currentConsent) {
    banner.classList.add('hidden');
    return;
  }

  // Reveal banner with smooth entrance after page settles
  setTimeout(() => {
    banner.classList.remove('hidden');
    requestAnimationFrame(() => {
      banner.classList.remove('opacity-0', 'translate-y-8', 'pointer-events-none');
      banner.classList.add('opacity-100', 'translate-y-0');
    });
  }, 1200);

  const hideBanner = () => {
    banner.classList.remove('opacity-100', 'translate-y-0');
    banner.classList.add('opacity-0', 'translate-y-8', 'pointer-events-none');
    setTimeout(() => {
      banner.classList.add('hidden');
    }, 400);
  };

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      try {
        if (typeof window !== 'undefined' && window.localStorage) {
          window.localStorage.setItem(consentKey, 'accepted');
        }
      } catch {
        // Safe fail
      }

      // Update Google Tag Manager Consent Mode v2 to granted
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
          analytics_storage: 'granted',
          personalization_storage: 'granted',
        });
      }

      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'cookie_consent_accepted' });

        // Grant consent to Microsoft Clarity
        if (typeof window.clarity === 'function') {
          window.clarity('consent');
        }
      }

      hideBanner();
    });
  }

  if (declineBtn) {
    declineBtn.addEventListener('click', () => {
      try {
        if (typeof window !== 'undefined' && window.localStorage) {
          window.localStorage.setItem(consentKey, 'declined');
        }
      } catch {
        // Safe fail
      }

      // Enforce Google Tag Manager Consent Mode to denied
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          analytics_storage: 'denied',
          personalization_storage: 'denied',
        });
      }

      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'cookie_consent_declined' });
      }

      // Purge any existing tracking cookies from browser
      purgeTrackingCookies();

      hideBanner();
    });
  }

  // Allow reopening consent modal from Cookie Policy page or footer
  if (typeof window !== 'undefined') {
    window.nbkOpenCookieBanner = () => {
      banner.classList.remove('hidden');
      requestAnimationFrame(() => {
        banner.classList.remove('opacity-0', 'translate-y-8', 'pointer-events-none');
        banner.classList.add('opacity-100', 'translate-y-0');
      });
    };
  }
}

/**
 * Actively removes non-essential analytics and tracking cookies from document.cookie
 */
function purgeTrackingCookies() {
  if (typeof document === 'undefined') return;

  const domain = window.location.hostname;
  const domainParts = domain.split('.');
  const rootDomain = domainParts.length > 2 ? '.' + domainParts.slice(-2).join('.') : '.' + domain;

  const cookies = document.cookie.split(';');
  cookies.forEach((cookie) => {
    const name = cookie.trim().split('=')[0];
    if (
      name === '_ga' ||
      name === '_gid' ||
      name === '_gat' ||
      name.startsWith('_ga_') ||
      name.startsWith('_clck') ||
      name.startsWith('_clsk') ||
      name === 'CLID' ||
      name === 'MUID' ||
      name === 'MR'
    ) {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain};`;
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${rootDomain};`;
      document.cookie = `${name}=; Max-Age=0; path=/;`;
    }
  });
}
